import React, { Fragment } from "react";
import { Field } from "react-final-form";
import { Error, RenderCheckbox, LinkLabel } from "./Elements";
import { withStyles } from "@material-ui/core/styles";
import TermsPrivacyFieldStyle from "./TermsPrivacyField.style";
import T from "Translate";
import Stack from "Common/Stack/Stack";
import MarketsSvc from "Services/markets/marketsSvc";

const PrivacyField = ({ values, validate, classes, onChange, country }) => {
    if (!MarketsSvc.hasPrivacyPolicy(country)) {
        return null;
    }

    return (
        <Fragment>
            <Stack display="flex" alignItems="start">
                <Field
                    name="privacypolicy"
                    component={RenderCheckbox}
                    type="checkbox"
                    label="Employed"
                    onChange={onChange}
                    validate={validate}
                    dataTestId="privacy"
                />
                <div className={`${classes.privacy_policy} text-upperCase`}>
                    <T>form_signup_privacy_label</T>
                    <br />
                    <p>
                        <T>form_signup_privacy_info</T>{" "}
                        <LinkLabel style={{ color: "#75A4D3" }}>
                            <T>privacy_notice</T>
                        </LinkLabel>
                    </p>
                </div>
            </Stack>
            <Error name="privacypolicy" className={classes.termsError} value={values} dataTestId="error_privacy" />
        </Fragment>
    );
};

export default withStyles(TermsPrivacyFieldStyle)(PrivacyField);



// WEBPACK FOOTER //
// ./src/components/StartContainer/TermsPrivacyField/PrivacyField.js